<template>
  <transition-group
      name="alert"
      tag="div"
      fullAlert
      :class="[isMiniVariant ? '-isMiniVariant' : '', $route.name === 'Login' ? '-isLogin' : '']">
    <template v-for="(alert) in alertsRegistered" >
      <DefaultAlert :key="alert.id" :alert="alert" @close-alert="removeAlert(alert)"/>
    </template>
  </transition-group>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import DefaultAlert from './DefaultAlert.vue';

export default {
  name: 'AlertManager',
  components: {
    DefaultAlert,
  },
  computed: {
    ...mapGetters({
      getterAlerts: 'application/alerts',
      isMiniVariant: 'application/isMiniVariant',
    }),
    alertsRegistered() {
      const alertsRegistered = [];
      this.getterAlerts.forEach((alert) => {
        let alreadyRegistered = false;
        alertsRegistered.forEach((alertRegistered) => {
          const alertCopy = { ...alert };
          const alertRegisteredCopy = { ...alertRegistered };
          delete alertCopy.id;
          delete alertCopy.time;
          delete alertRegisteredCopy.id;
          delete alertRegisteredCopy.time;
          if (JSON.stringify(alertCopy) === JSON.stringify(alertRegisteredCopy)) {
            alreadyRegistered = true;
          }
        });
        if (alert.type === 'success' && alert.time < new Date().getTime() - 5000) {
          return;
        }
        if (!alreadyRegistered) {
          alertsRegistered.push(alert);
        }
      });
      return alertsRegistered;
    },
  },
  methods: {
    ...mapActions({
      storeRemoveAlert: 'application/removeAlert',
      storeResetAlert: 'application/resetAlert',
    }),
    removeAlert(alert) {
      this.storeResetAlert(this.alertsRegistered).then(() => {
        this.storeRemoveAlert(alert.id);
      });
    },
  },
};
</script>
